import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import './navigation.css';

const Navigation = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { name: 'Computer Science Engineering', path: '/Cse' },
    { name: 'Electronics and Communication Engineering', path: '/Ece' },
    { name: 'Mechanical Engineering', path: '/Mech' },
    { name: 'Electrical and Electronics Engineering', path: '/EEE' },
    { name: 'General Department', path: '/general' },
  ];

  useEffect(() => {
    // Set default navigation to CSE if the current path does not match any menu item
    const defaultPath = '/Cse';
    const activePathIndex = menuItems.findIndex((item) => item.path === location.pathname);

    if (activePathIndex === -1 || location.pathname === '/') {
      navigate(defaultPath); // Navigate to the default path
      setActiveIndex(0); // Highlight the default menu item
    } else {
      setActiveIndex(activePathIndex); // Set the active index if a valid path is present
    }
  }, [navigate, location.pathname, menuItems]);

  const handleItemClick = (index, path) => {
    setActiveIndex(index);
    navigate(path); // Navigate to the corresponding route
  };

  return (
    <div style={{width:"100%"}}>
      <nav>
        {menuItems.map((item, index) => (
          <li
            key={index}
            className={activeIndex === index ? 'active' : ''}
            onClick={() => handleItemClick(index, item.path)}
          >
            {item.name}
          </li>
        ))}
      </nav>
    </div>
  );
};

export default Navigation;
